<div [ngSwitch]="type">
    <div *ngIf="data.download" align="end">
        <button mat-icon-button color="accent" (click)="downloadFile()">
            <mat-icon>download</mat-icon>
        </button>
    </div>
    <!--PDF-->
    <div *ngSwitchCase="'application/pdf'">
        <object type="application/pdf"
            [data]="base64"
            width="500"
            height="450">
        </object>
    </div>
    <!--PNG-->
    <div *ngSwitchCase="'image/png'">
        <object type="image/png"
            [data]="base64"
            width="auto"
            height="auto">
        </object>
    </div>
</div>
